import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  useGetServiceCategoryQuery,
  useGetServicesQuery,
} from "../redux/services/api";
import Header from "../components/Header";
import Footer from "../components/Footer";
import FloatingButtons from "../components/FloatingButtons";
import { createExcerpt, parseDraftContent } from "../utils/excerpt";
import { useTranslation } from "../hooks/useTranslation";
import { useLanguage } from "../contexts/LanguageContext";
import AOS from "aos";
import "aos/dist/aos.css";

const ServiceCategoryPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t, isArabic } = useTranslation();
  const { getLocalizedPath } = useLanguage();

  const { data: categoryData, isLoading: loadingCategory } =
    useGetServiceCategoryQuery(id);
  const { data: servicesData, isLoading: loadingServices } =
    useGetServicesQuery();

  const category = categoryData?.category || null;
  const services =
    servicesData?.services?.filter(
      (service) => service.is_active && service.category_id == id
    ) || [];

  const isLoading = loadingCategory || loadingServices;

  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: "ease-in-out",
      once: true,
      offset: 100,
    });
  }, []);

  const handleServiceClick = (serviceId) => {
    navigate(getLocalizedPath(`/service/${serviceId}`));
  };

  const handleBackToServices = () => {
    navigate(getLocalizedPath("/services"));
  };

  if (isLoading) {
    return (
      <div className="services-page category-services-page">
        <div className="container">
          <div className="loading-container">
            <div className="loading-spinner"></div>
            <p>{t("services.loadingServices")}</p>
          </div>
        </div>
      </div>
    );
  }

  if (!category) {
    return (
      <div className="services-page category-services-page">
        <Header />
        <div className="container">
          <div className="error-container">
            <h1>{t("addEditCategory.categoryNotFound")}</h1>
            <p>{t("addEditCategory.categoryNotFoundMessage")}</p>
            <button className="btn" onClick={handleBackToServices}>
              {t("services.viewAll")}
            </button>
          </div>
        </div>
        <Footer />
        <FloatingButtons />
      </div>
    );
  }

  return (
    <div className="services-page category-services-page">
      <Header />
      <div className="container">
        <div className="page-title-section" data-aos="fade-up" data-aos-delay="100">
          <h1>
            {isArabic && category.title_ar ? category.title_ar : category.title}
          </h1>
          {(category.description || category.description_ar) && (
            <div
              className="category-description"
              dangerouslySetInnerHTML={{
                __html: parseDraftContent(
                  isArabic && category.description_ar
                    ? category.description_ar
                    : category.description
                ),
              }}
            />
          )}
        </div>

        <div className="services-grid-page">
          {services.length === 0 ? (
            <div className="no-services" data-aos="fade-up" data-aos-delay="200">
              <p>{t("services.noServicesInCategory")}</p>
            </div>
          ) : (
            services.map((service, index) => (
              <div
                key={service.id}
                className="service-item clickable-service-item"
                data-aos="fade-up"
                data-aos-delay={`${200 + index * 100}`}
                onClick={() => handleServiceClick(service.id)}
                style={{ cursor: "pointer" }}
              >
                <div className="service-content">
                  <div className="service-title-box">
                    <span>
                      {isArabic && service.title_ar
                        ? service.title_ar
                        : service.title}
                    </span>
                  </div>
                  <div className="service-description">
                    {createExcerpt(
                      isArabic && service.content_ar
                        ? service.content_ar
                        : service.content,
                      20
                    )}
                  </div>
                  <button
                    className="learn-more-btn"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleServiceClick(service.id);
                    }}
                  >
                    {t("common.learnMore")}
                  </button>
                </div>
                <div className="service-image-container">
                  {service.image_url ? (
                    <img
                      src={service.image_url}
                      alt={
                        isArabic && service.title_ar
                          ? service.title_ar
                          : service.title
                      }
                      className="service-image"
                    />
                  ) : (
                    <div className="service-placeholder">
                      <span>{t("services.servicePic")}</span>
                    </div>
                  )}
                </div>
                {index < services.length - 1 && (
                  <div className="service-separator"></div>
                )}
              </div>
            ))
          )}
        </div>
      </div>
      <Footer />
      <FloatingButtons />
    </div>
  );
};

export default ServiceCategoryPage;

